import { Component } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { TranslateModule } from "@ngx-translate/core";
import { ButtonModule } from "primeng/button";
import { ButtonComponent } from "@kernel/shared/modules/button/components/button/button.component";

@Component({
  selector: "sxw-confirmation-dialog",
  templateUrl: "./confirmation-dialog.component.html",
  styleUrls: ["./confirmation-dialog.component.scss"],
  imports: [TranslateModule, ButtonModule, ButtonComponent],
})
export class ConfirmationDialogComponent {
  constructor(
    public config: DynamicDialogConfig,
    private ref: DynamicDialogRef
  ) {}

  accept() {
    this.ref.close(true);
  }

  reject() {
    this.ref.close(false);
  }
}
